import { Component, OnInit, Input } from '@angular/core';
import { Subscription } from 'rxjs';

import * as moment from 'moment';
import * as _ from 'lodash';

import { UtilService } from 'src/app/modules/shared/services/util.service';
import { CouponsService } from 'src/app/modules/cpg/services/coupons.service';
import { MessageService } from 'src/app/modules/shared/services/message.service';
@Component({
  selector: 'app-create-coupon-preview',
  templateUrl: './create-coupon-preview.component.html',
  styleUrls: ['./create-coupon-preview.component.scss']
})
export class CreateCouponPreviewComponent implements OnInit {

  @Input() module: string; // (CPG/RETAILER)
  @Input() couponData: any;

  public updatePreviewSubscription: Subscription; // Subscription from update preview

  constructor(
    private _utilService: UtilService,
    private _couponsService: CouponsService,
    private _messageService: MessageService
  ) {
    // Subscribe to items page messages
    this.updatePreviewSubscription = this._messageService.getMessage().subscribe(message => {
      if (message) {
        if (message.data.id === 'message-updatePreview') {
          this.getStorageData();
        }
      }
    });
  }

  ngOnInit(): void {
    this.getStorageData();
  }

  async getStorageData() {
    if (this.module == 'CPG') {
      this.couponData = await this._utilService.getStorageData('C_NEW_COUPON');
    } else if (this.module == 'RETAILER') {
      this.couponData = await this._utilService.getStorageData('R_NEW_COUPON');
    }
  }

  ngOnDestroy() {
    this.updatePreviewSubscription.unsubscribe();
  }

}
